module.exports = __webpack_public_path__ + "static/media/amd.e77be593.svg";